import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@material-ui/core';

const GstnTableValidation = ({ data, gstinDetailData }) => {
  const containerStyle = {
    position: 'relative',
    margin:'20px'
  };

  const tableStyle = {
    border: '1px solid black', // Thin black border
    position: 'relative',
    paddingtop:"30px"
  };

  const boxStyle = {
    width: '120px', // Adjust width as needed
    height: '20px', // Adjust height as needed
    backgroundColor: '#fff', // Background color of the box
    border: '1px solid black', // Border style of the box
    position: 'absolute',
    top: '-10px', // Adjust the distance from the top border
    left: '15%', // Center the box horizontally
    transform: 'translateX(-50%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 'bold',
    zIndex: 1, // Ensure the box appears above the border
  };

  const rowStyle = (index) => {
    // Alternate row background color
    // return index % 2 === 0 ? { backgroundColor: '#f5f5f5' } : {};
    return { backgroundColor: index % 2 === 0?'#f5f5f5':'white' };
  };
  console.log("Data :: ", data);
  return (
    <div style={containerStyle} className='gstinDetailContainer'>
      {(gstinDetailData.error == 0)?(
      <>
      <div style={boxStyle}>GSTIN Details</div>
      <TableContainer component={Paper} style={tableStyle}>
        <Table>
          <TableBody>
            {Object.keys(data).map((key, index) => (
              <TableRow key={key} style={rowStyle(index)}>
                <TableCell component="th" scope="row" style={{ fontWeight: 'bold', width: "45%" }}>
                  {key.replace(/_/g, ' ')}
                </TableCell>
                <TableCell>{data[key]}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </>):(
        <Typography style={{width:"100%", height:"4em", textAlign:"center", fontWeight:"800"}}>{gstinDetailData.message}</Typography>
      )}
    </div>
  );
};

export default GstnTableValidation